/**
 * @deprecated Temporary solution for cases where settings must be managed without
 * Translation Management support.
 *
 * This component exists only to bypass translation dependencies in `SettingsBoxBase`
 * If such separation is required long-term, `SettingsBoxBase` should be refactored
 * to use the Composition API for better modularity and reuse.
 */
import AdminComponentBase from '@/Components/Admin/AdminComponentBase';
import FormModelHelpers from '@/Mixins/FormModelHelpers';
import HighlighterHelpers from '@/Mixins/Admin/HighlighterHelpers';
import { mapObject } from '@/Utils';

export default {
    extends: AdminComponentBase,
    mixins: [FormModelHelpers, HighlighterHelpers],
    methods: {
        loadSettings() {
            return this.wrapAsyncTask(this.loadSettingsPromise()
                .then(this.handleLoadSettingsPromiseResolved))
                .then(() => this.$validator.reset())
                .then(() => this.initialized());
        },
        saveSettings() {
            this.$validator.resume();
            this.$validator.validateAll()
                .then(validationPassed => {
                    if (validationPassed) {
                        this.wrapAsyncTask(this.wrapApiAction(this.saveSettingsPromise(), 'model.')
                            .then(() => {
                                this.$notify.popupSuccess('Your changes have been saved.', { qa: 'ChangesSaved' });
                                return this.loadSettings();
                            }));
                    }
                });
        },
        updateModel(data) {
            mapObject(data, this.model);
        },
        handleLoadSettingsPromiseResolved(result) {
            if (result && result.data) {
                this.updateModel(result.data);
            }

            this.$nextTick(() => {
                this.hasChanged = false;
            });

            return this.onLoadSettingsSuccess(result ? result.data || null : null);
        },
        initialized() {
            // by default do nothing
            // it could be overridden by other components
        },
        onLoadSettingsSuccess() {
            // by default do nothing
            // it could be overridden by other components
            return Promise.resolve();
        },
    },
    mounted() {
        this.ensureStoreInitialized().then(this.loadSettings);
    },
};